import { useEffect } from 'react';
import amplitude from '../services/amplitude';
import { SPLASH_DURATION } from '@autopass-web/mochi-component';

export const useAmplitudeEntryPageView = (isInit: boolean) => {
  useEffect(() => {
    if (isInit === false) return;

    setTimeout(() => {
      amplitude.entryPageView();
      // Waiting 900 ms for the Splash component to run the animation
    }, SPLASH_DURATION);
  }, [isInit]);
};
